import React, { useState } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  DatePicker,
  InputNumber,
  Input,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const PrematureRedemption = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        transactionDate: values.transactionDate?.format("YYYY-MM-DD"),
        transactionAmount: values.transactionAmount,
        note: values.note,
      };
      // await BOM.SendReq(apiConfig.prematureRedemption, { id, ...payload });
      console.log("PrematureRedemption payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Premature redemption processed successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(
        cnt.DANGER,
        error?.message || "Failed to process premature redemption.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const LabelWithTip = ({ text, tip }) => (
    <span>
      {text}
      <Tooltip title={tip}>
        <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
      </Tooltip>
    </span>
  );

  return (
    <MainLayout pageItems={staticConfig.manageTBContract}>
      <TopContent pageTitle={labelConfig.tbContract} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Premature Redemption
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              {/* Transaction Date & Transaction Amount */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <LabelWithTip
                        text="Transaction Date"
                        tip="The date on which the early redemption is processed."
                      />
                    }
                    name="transactionDate"
                    rules={[
                      {
                        required: true,
                        message: "Transaction date is required",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="YYYY-MM-DD"
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <LabelWithTip
                        text="Transaction Amount"
                        tip="The redemption amount to be paid out to the client."
                      />
                    }
                    name="transactionAmount"
                    rules={[
                      {
                        required: true,
                        message: "Transaction amount is required",
                      },
                      {
                        type: "number",
                        min: 1,
                        message: "Amount must be greater than 0",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 49,500,000.00"
                      formatter={(v) =>
                        v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Note */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <LabelWithTip
                        text="Note"
                        tip="Optional remarks about this early redemption."
                      />
                    }
                    name="note"
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="e.g. Early redemption at client request"
                      style={{
                        resize: "none",
                        borderRadius: 8,
                        fontSize: 14,
                        padding: "10px 12px",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Process Redemption
                  </button>
                </Col>
              </Row>
              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(PrematureRedemption);
